// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2I3X6","signatureBlock":"Footer_signatureBlock__ILj-f","signature":"Footer_signature__DjMhL"};